import React, { Component } from 'react';

import { Modal } from 'antd';

import Input from '../../UI/Input';
import Button from '../../UI/Button';

import AddressWrapper from './address.style';

class ModifyAddressModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      line1: this.props.address.line1,
      line2: this.props.address.line2,
    };
  }

  updateAddress = (line, e) => {
    this.setState({
      ...this.state,
      [line]: e.target.value,
    });
  }

  render() {
    return (
      <Modal
        visible={this.props.open}
        title="Adres wijzigen"
        footer={[
          <Button key="back" size="large" onClick={this.props.onClose}>
            Annuleren
          </Button>,
          <Button
            key="submit"
            type="primary"
            size="large"
            onClick={() => {
              this.props.onConfirm(this.state);
            }}
          >
            Bevestigen
          </Button>,
        ]}
      >
        <AddressWrapper>
            <div className="isoInputWrapper">
              <Input size="large" placeholder="Straatnaam + Huisnummer" defaultValue={this.props.address.line1} onChange={(e) => this.updateAddress('line1', e)} />
            </div>

            <div className="isoInputWrapper">
              <Input size="large" placeholder="Postcode + Plaats" defaultValue={this.props.address.line2} onChange={(e) => this.updateAddress('line2', e)} />
            </div>
        </AddressWrapper>
      </Modal>
    );
  }
}

export default ModifyAddressModal;


// WEBPACK FOOTER //
// ./src/components/Orders/Modals/ModifyAddressModal.js